<template>
    <!--
          作者：kmdshop
          时间：2019-10-25
          描述：会员-添加
      -->
    <el-dialog title="区域代理设置" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-form size="small" ref="formData" :model="formData"  label-width="200px">
            <!-- <el-form-item label="开关：" prop="status" >
                    <el-radio-group v-model="formData.status" @change="open">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                    </el-radio-group>
                </el-form-item> -->
                <el-form-item label="当前城市：" prop="reference" >
                    <div style="display: flex;width: 100%;">
                        <div style="flex: 1;">{{ formData.long_name }}</div>
                    </div>
                 
                </el-form-item>

                <el-form-item label="参考数据：" prop="reference" v-if="formData.company_num || formData.population">
                    <div style="display: flex;width: 100%;">
                        <div style="flex: 1;" v-if="formData.company_num">总参考企业数量：{{formData.company_num}}个</div>
                        <div  style="flex: 1;" v-if="formData.population">总参考人口数量：{{formData.population}}人</div>
                    </div>
                </el-form-item>

                <el-form-item label="总客户数量：" prop="reference" v-if="formData.customer_num_all">
                    <div style="display: flex;width: 100%;">
                        <div style="flex: 1;" >{{formData.customer_num_all}}个</div>
                    </div>
                </el-form-item>

                <el-form-item label="总市场总额：" prop="reference" v-if="formData.market_total_all">
                    <div style="display: flex;width: 100%;">
                        <div style="flex: 1;" >{{formData.market_total_all}}</div>
                    </div>
                </el-form-item>

                <el-form-item label="直管客户数量预估：" prop="customer_num">
                    <el-input type='number'  v-model="formData.customer_num" class="max-w460"></el-input>
                </el-form-item>

                <el-form-item label="直管客户单价：" prop="customer_per_price">
                    <el-input type='number'  v-model="formData.customer_per_price" class="max-w460"></el-input>
                </el-form-item>

                <el-form-item label="直管市场总额：" prop="reference" >
                    <div style="display: flex;width: 100%;">
                        <div style="flex: 1;" >{{formData.customer_num * formData.customer_per_price}}元</div>
                    </div>
                </el-form-item>
 

                <div>
        <el-button size="small" type="primary" style="float:right;" @click="onSubmit">保存</el-button>
        <div style="clear: both;"></div>
      </div>
          </el-form>


    </el-dialog>
  </template>
  
  <script>
  import CityApi from '@/api/city.js';
    import RegionagentApi from '@/api/regionagent.js';
    export default {
      data() {
        return {
          /*是否加载完成*/
          loading: true,
          /*当前是第几页*/
          curPage: 1,
          /*一页多少条*/
          pageSize: 20,
          /*一共多少条数据*/
          totalDataNumber: 0,
          formData: {
            // status: 1,
            customer_per_price:0,
            market_total:0,
            customer_num:0,
            region_agent_district_id:"",
            customer_num_all:0,
            market_total_all:0,
            long_name:"",
            company_num:0,
            population:0,
          },
          //会员列表
          tableData: [],
          formRules: {
            customer_num: [{
                required: true,
                message: '请输入客户数量预估',
                trigger: 'blur'
              },
            ],
            customer_per_price:[{
                required: true,
                message: '请输入客户单价',
                trigger: 'blur'
            }]
          },
          multipleSelection: [],
          /*左边长度*/
          formLabelWidth: '120px',
          /*是否显示*/
          dialogVisible: false,
          disabled:false
        };
      },
      props: ['open_add',"obj"],
      created() {
        var self = this;
        this.dialogVisible = this.open_add;

        console.log(this.formData)
        var params = {
            id:this.obj.id,
            level:this.obj.level
        }
        RegionagentApi.getSettings(params, true).then(res => {
            console.log(res)
            if(res.msg == "获取成功"){
                console.log("???")
                self.formData = {
                    // status: res.data.status,
                    customer_per_price:res.data.customer_per_price,
                    market_total:res.data.market_total,
                    customer_num:res.data.customer_num,
                    region_agent_district_id:res.data.region_agent_district_id,
                    customer_num_all:res.data.customer_num_all,
                    market_total_all :res.data.market_total_all,
                    long_name:res.data.long_name,
                    company_num:res.data.company_num,
                    population:res.data.population,
                }
              
            }
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
      },
      methods: {
        
        /*提交表单*/
        onSubmit() {
        let self = this;
        let params = this.formData;
        params.id = this.obj.id;
        params.level = this.obj.level
        params.market_total = params.customer_num * params.customer_per_price
        console.log(params)
        RegionagentApi.setting(params, true).then(res => {
            console.log(res)
            if(res.msg == "设置成功"){
                self.$message({
                message:"设置成功",
                type: 'success'
              });
              self.dialogFormVisible(false);   
            }else{
              self.flag = true;
                self.$message({
                message: res.msg,
                type: 'error'
              });
            }
            self.loading=false;
          })
          .catch(error => {
            self.loading=false;
          });
        },
        open(e){
        console.log(e)
        this.disabled = e==0?true:false;
        },
  
        //点击确定
        selectUser(e) {
          let self = this;
          let params = e;
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false,
            params: params
          });
        },
  
        /*关闭弹窗*/
        dialogFormVisible(e) {
          if (e) {
            this.$emit('closeDialog', {
              type: 'success',
              openDialog: false
            });
          } else {
            this.$emit('closeDialog', {
              type: 'error',
              openDialog: false
            });
          }
        },
      }
    };
  </script>
  
  <style></style>
  


// WEBPACK FOOTER //
// src/views/plus/city/index/setting.vue